(() => {
  const stickyBar = document.querySelector('[data-modeamore-sticky-atc]');
  if (!stickyBar || !window.matchMedia('(max-width: 749px)').matches) return;

  const formId = stickyBar.dataset.productFormId;
  const productForm = document.getElementById(formId);
  const submitButton = productForm && productForm.querySelector('[name="add"]');
  const stickyButton = stickyBar.querySelector('[data-modeamore-sticky-submit]');
  const stickyVariant = stickyBar.querySelector('[data-modeamore-sticky-variant]');
  const stickyPrice = stickyBar.querySelector('[data-modeamore-sticky-price]');

  if (!productForm || !submitButton || !stickyButton) return;

  stickyButton.addEventListener('click', () => submitButton.click());

  const syncButtonState = () => {
    stickyButton.disabled = submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true';
    const sourceText = submitButton.querySelector('span');
    if (sourceText) stickyButton.textContent = sourceText.textContent.trim();
  };

  const syncVariantText = () => {
    const checkedOptions = Array.from(document.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked'))
      .map((option) => option.value)
      .filter(Boolean);

    if (stickyVariant) stickyVariant.textContent = checkedOptions.join(' / ');

    const visiblePrice = document.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    if (visiblePrice && stickyPrice) stickyPrice.textContent = visiblePrice.textContent.trim();
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      const shouldShow = !entry.isIntersecting && window.scrollY > 240;
      stickyBar.hidden = false;
      stickyBar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('modeamore-sticky-atc-visible', shouldShow);
    },
    { threshold: 0 }
  );

  observer.observe(productForm);

  const mutationObserver = new MutationObserver(() => {
    syncButtonState();
    syncVariantText();
  });

  mutationObserver.observe(productForm, { attributes: true, childList: true, subtree: true });
  document.addEventListener('change', syncVariantText);
  syncButtonState();
  syncVariantText();
})();
